import { Assert } from '@team/assert';
import { fromEntries } from './from-entries.js';
import { toEntries } from './to-entries.js';

type SnakeToCamelCaseKey<S extends string> =
  S extends `${infer T}_${infer U}_${infer V}`
    ? `${T}${Capitalize<U>}${Capitalize<SnakeToCamelCaseKey<V>>}`
    : S extends `${infer T}_${infer U}`
      ? `${T}${Capitalize<SnakeToCamelCaseKey<U>>}`
      : S;

export type SnakeToCamelCase<T> = T extends UnknownObject
  ? {
      [K in keyof T as SnakeToCamelCaseKey<K & string>]: T[K];
    }
  : T;

function snakeToCamelKey(str: string): string {
  return str.replace(/_([a-z0-9])/g, (match) => match[1].toUpperCase());
}

export function snakeToCamelFlat<T>(input: T): SnakeToCamelCase<T>;
export function snakeToCamelFlat(input: UnknownObject): UnknownObject {
  if (!Assert.isUnknownObject(input)) {
    return input;
  }

  return fromEntries(
    toEntries(input).map(([key, value]) => [snakeToCamelKey(key), value])
  );
}
